﻿import { f7 } from 'framework7-react';
import { FC } from 'react';
import style from './carAssetValueStyle.module.css';
import carDefault from '@/assets/images/carImg.svg';
import { paths } from '@/config/paths';
import { RecommendedCarItem } from '@/types/api/recommendedCarApi';

interface RecommendedCarsSectionProps {
  cars: RecommendedCarItem[];
  isLoading: boolean;
  errorMessage: string | null;
}

export const RecommendedCarsSection: FC<RecommendedCarsSectionProps> = ({
  cars,
  isLoading,
  errorMessage,
}) => {
  if (isLoading) {
    return (
      <div className={style['recommend-loading']}>
        <span>おすすめ車種を取得中...</span>
      </div>
    );
  }

  if (errorMessage || cars.length === 0) {
    return null;
  }

  return (
    <section className={style['recommend-section']}>
      <p className={style['recommend-title']}>あなたにおすすめの車種</p>
      <div className={style['recommend-list']}>
        {cars.map((car) => (
          <article
            key={`${car.mk_cd}-${car.carnm_cd}`}
            className={style['recommend-card']}
            onClick={() =>
              f7.view.main.router.navigate(
                paths.recommendedCarCatalog(
                  String(car.mk_cd),
                  String(car.carnm_cd),
                ),
              )
            }
          >
            <img
              src={car.image_url ?? carDefault}
              alt={`${car.maker_nm} ${car.car_nm}`}
              className={style['recommend-image']}
              onError={({ currentTarget }) => {
                currentTarget.src = carDefault;
              }}
            />
            <p className={style['recommend-maker']}>{car.maker_nm}</p>
            <p className={style['recommend-name']}>{car.car_nm}</p>
          </article>
        ))}
      </div>
    </section>
  );
};

